interface Lehrform {
    lehrformName: string
    kontaktzeit: string
    selbststudium: string
    gesamt: string
}

function parseKommaToFloat(newValue: string) {
    return newValue.replace(',', '.')
}

const formatLehrformAsFloat = (lehrform: Lehrform) => {
    const gesamt = lehrform.gesamt
    lehrform.gesamt = parseKommaToFloat(gesamt).toString()

    return lehrform
}

function formatLehrformToDE(lehrform: Lehrform) {
    const gesamt = lehrform.gesamt
    lehrform.gesamt = new Intl.NumberFormat('de-DE').format(parseFloat(gesamt))

    return lehrform
}

export { formatLehrformToDE, formatLehrformAsFloat, parseKommaToFloat }
